module.exports = __webpack_public_path__ + "static/naval-ravikant-9ac8c431cf5e78c56ec8ed2f0846efab.jpg";